export default class mainlandfreightdetail {
    id: number;
    warehouseInfoId: number;
    warehouseName: string;
    beginTime?: Date;
    endTime?: Date;
    isEffective: boolean;
    baseCost: number;
    baseSkuNums: number;
    exceedBaseSkuNums: number;
    exceedSkuCost: number;
    maxSkuCost: number;
    sackPrice: number;
    orderType: number;
}